export const SETUP_CUSTOMER_PORTAL = 'SETUP_CUSTOMER_PORTAL';
export const SETUP_CUSTOM_DOMAIN = 'SETUP_CUSTOM_DOMAIN';